var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 12,
    viewBox: "0 0 49 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.47009 2.34868H0V0H9.44426V2.34868H5.97418V11.5759H3.46594V2.34868H3.47009Z",
    fill: "#282828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3691 0H19.9676V2.26495H13.8608V4.61363H19.2338V6.87858H13.8608V9.31099H20.0464V11.5759H11.3691V0Z",
    fill: "#282828"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2795 0H26.9353C29.655 0 31.3009 1.63696 31.3009 4.00239V4.03588C31.3009 6.7153 29.2487 8.10525 26.6907 8.10525H24.7836V11.5801H22.2754V0H22.2795ZM26.7736 5.8403C28.0257 5.8403 28.7595 5.07834 28.7595 4.08612V4.05263C28.7595 2.90969 27.9759 2.29844 26.7239 2.29844H24.7878V5.83612H26.7736V5.8403Z",
    fill: "#282828"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2695 0H35.7778V11.5759H33.2695V0Z",
    fill: "#282828"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.627 0H41.1352V5.0616L45.7578 0H48.7884L44.1492 4.91088L48.9999 11.5759H45.9858L42.4536 6.64832L41.1352 8.03827V11.5759H38.627V0Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4adc4c925be19a8ddef4a67525c41355.svg";
export { ForwardRef as ReactComponent };